<app-pageheader [Parent]="this">
  <add-button AddRoute="/parking/accesscontrol/customergroups/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="parking/customergroups/searches"
[AllowEdit]="true" EditUrl="/parking/accesscontrol/customergroups/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 